import { useFormikContext, withFormik } from "formik";
import { StatusCodes } from "http-status-codes";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import * as yup from "yup";
import { AuthShell } from "../register/auth-shell";
import "../register/auth-ui.css";
import { OrButton } from "../shared_modules/ui/components/atoms/or-button/or-button";
import { MdiEye, MdiEyeOff } from "../shared_modules/ui/components/atoms/or-icon";
import { OrInput } from "../shared_modules/ui/components/atoms/or-input/or-input";
import { showOrToast } from "../shared_modules/ui/components/atoms/or-toast/or-toast";
import { useUserRepository } from "../user/useUserRepository";

export default function EmailChangeValidator() {
  const { login, validateChangeEmail } = useUserRepository();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const token = searchParams.get("token");

  if (!token) {
    navigate("/login");
  }

  const FormView = (props) => {
    const { setFieldValue } = useFormikContext();
    const { values, touched, errors, isSubmitting, handleChange, handleSubmit } = props;

    return (
      <form className="or-auth-form" onSubmit={handleSubmit}>
        <div className="or-auth-form__group">
          <OrInput
            id="email"
            inputType="email"
            label="Email *"
            name="email"
            onChange={handleChange}
            placeholder="tu@email.com"
            value={values.email}
            hasError={touched.email && Boolean(errors.email)}
            errorText={touched.email ? errors.email : ""}
          />
        </div>

        <div className="or-auth-form__group">
          <OrInput
            id="password"
            inputType={values.showPassword ? "text" : "password"}
            label="Contraseña *"
            name="password"
            onChange={handleChange}
            placeholder="********************"
            rightSlot={
              <button
                className="or-auth-password-toggle"
                id="passwordicon"
                type="button"
                aria-label="toggle password visibility"
                onClick={() => setFieldValue("showPassword", !values.showPassword)}
              >
                {values.showPassword ? <MdiEyeOff /> : <MdiEye />}
              </button>
            }
            value={values.password}
            hasError={touched.password && Boolean(errors.password)}
            errorText={touched.password ? errors.password : ""}
          />
        </div>

        <div className="or-auth-form__group">
          <OrButton type="submit" fullWidth isLoading={isSubmitting} size="lg" variant="primary">
            Actualizar Email
          </OrButton>
        </div>
      </form>
    );
  };

  const validationsForm = {
    email: yup.string().email("Escribe un email válido").required("El email es requerido"),
    password: yup
      .string()
      .min(8, "La contraseña es demasiado corta. debe tener un mínimo de 8 caracteres.")
      .required("La password es requerida"),
  };

  const Form = withFormik({
    mapPropsToValues: ({ email, password }) => {
      return {
        email: email || "",
        password: password || "",
      };
    },

    enableReinitialize: true,
    validationSchema: yup.object().shape(validationsForm),
    handleSubmit: async (values) => {
      try {
        let result = await login({ username: values.email, password: values.password });

        if (result.status === StatusCodes.OK) {
          try {
            let resultValidate = await validateChangeEmail(
              {
                token: token,
              },
              result.data.token,
            );

            if (resultValidate) {
              showOrToast("¡Email cambiado!");
              navigate("/login");
            } else {
              showOrToast("No hemos podido cambiar el email", { type: "error" });
            }
          } catch (error) {
            showOrToast("No hemos podido cambiar el email", { type: "error" });
          }
        }
      } catch (error) {
        showOrToast("Usuario o contraseña incorrecta", { type: "error" });
      }
    },
  })(FormView);

  return (
    <AuthShell
      title="Cambio de email"
      subtitle="Inicia sesión con tu cuenta para confirmar el cambio de dirección de correo electrónico"
      footer={
        <>
          <p className="or-auth-form__hint">
            ¿Ya estás registrado? <Link to="/login">Inicia sesión</Link>
          </p>
          <a href="https://openreferences.com/aviso-legal/" target="_blank" rel="noreferrer">
            Términos y Condiciones
          </a>
        </>
      }
    >
      <Form />
    </AuthShell>
  );
}
